module.exports = __webpack_public_path__ + "img/5.5e24e1f7.png";